"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledShade = exports.ShadeWrapper = exports.Root = exports.PriceAndButton = exports.Info = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _ProductInfo = require("./components/ProductInfo");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'center'
}));
const Info = exports.Info = (0, _mui.styled)('a')(({
  theme
}) => ({
  flexBasis: '50%',
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  flexShrink: 0,
  '&:hover, &:focus': {
    [`.${_ProductInfo.productInfoNameClassName}`]: {
      textDecoration: 'underline'
    }
  }
}));
const PriceAndButton = exports.PriceAndButton = (0, _mui.styled)('div')(({
  theme
}) => ({
  flexBasis: '50%',
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexGrow: 1,
  paddingRight: '3px' // To prevent overflow on Favorites Shadow when animating to right side
}));
const ShadeWrapper = exports.ShadeWrapper = (0, _mui.styled)('div')({
  flexShrink: 0
});
const StyledShade = exports.StyledShade = (0, _mui.styled)(_presentationComponents.Shade)({
  cursor: 'pointer'
});
